import $ from 'jquery';
import Flickity from 'flickity';
import rimg from 'rimg-shopify';
import resizeFlickityIfNeeded from '../helpers/flickityHelper';

export default class DynamicSlideshow {
  constructor({ el, data }) {
    this.$el = $(el);
    this.data = data;
    rimg.watch(el);
    this.$slideshow = $('[data-slideshow]', this.$el);
    this.$slides = $('[data-slideshow-slide]', this.$el);
    this.$slideContents = $('.slideshow', this.$el).children('[data-slide-contents]');
    this.autoplay = this.data.should_autoplay && this.data.autoplay_timing
      ? this.data.autoplay_timing * 1000
      : false;

    if (this.data.slide_count > 1) {
      this._initFlickity();
      this._bindEvents();
      this.slideImageLoaded = () => resizeFlickityIfNeeded(this.flickity);
      this.$slideshow[0].addEventListener('rimg:load', this.slideImageLoaded);
    }
  }

  _bindEvents() {
    this.$slides.on('focusin.slideshow', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const slideIndex = this.$slides.index($(event.currentTarget));
      this.flickity.select(slideIndex, false, true);
      this.flickity.reloadCells();
    });

    this.flickity.on('select', (index) => {
      this._updateSlideContent(index);
    });
  }

  _updateSlideContent(index) {
    this.$slideContents.removeClass('slide-contents-visible')
      .filter(`[data-slide-index=${index}]`)
      .addClass('slide-contents-visible');
  }

  _unbindEvents() {
    this.$slides.off('focusin.slideshow');
    this.flickity.off('select');
    this.$slideshow[0].removeEventListener('rimg:load', this.slideImageLoaded);
  }

  _initFlickity() {
    this.flickity = new Flickity(this.$slideshow[0], {
      accessibility: true,
      adaptiveHeight: true,
      autoPlay: this.autoplay,
      cellAlign: 'left',
      cellSelector: '[data-slideshow-slide]',
      friction: 0.3,
      pageDots: false,
      pauseAutoPlayOnHover: true,
      prevNextButtons: true,
      selectedAttraction: 0.025,
      wrapAround: true,
    });
  }

  onSectionBlockSelect(block) {
    if (!this.flickity) {
      return;
    }
    const $slides = $('[data-slideshow-slide]', this.$el);
    const slideIndex = $slides.index($(block.el));

    this.flickity.select(slideIndex, false, false);

    if (this.autoplay) {
      this.flickity.stopPlayer();
    }
  }

  onSectionBlockDeselect() {
    if (this.flickity && this.autoplay) {
      this.flickity.playPlayer();
    }
  }

  onSectionUnload() {
    if (this.flickity) {
      this.flickity.destroy();
    }
    this._unbindEvents();
  }
}
